<template>
  <div>
    <div class="row d-flex justify-content-center">
      <div class="col-lg-12">
        <template class="header">
          <h4 class="card-title style-title">Pickup Edit</h4>
          <h5 class="description style-title">
            Please fill in all the required details to edit Pickup Schedule.
          </h5>
        </template>
      </div>
    </div>
    <div class="row d-flex justify-content-center">
      <div class="col-lg-12">
        <card>
          <div class="row justify-content-center">
            <div class="col-lg-12">
              <h4 class="card-title style-title">Pickup Details</h4>
            </div>
          </div>
          <div class="row justify-content-center">
            <!-- Select Site/Route, PickupPoint Name and Lat/Long -->
            <div class="col-lg-2">
              <base-input label="1. Region">
                <el-select
                  class="select-danger"
                  placeholder="Region"
                  v-model="region"
                >
                  <el-option
                    v-for="region in regions"
                    class="select-danger"
                    :value="region.value"
                    :label="region.label"
                    :key="region.label"
                  ></el-option>
                </el-select>
              </base-input>
              <base-input label="2. Select Route">
                <el-select
                  class="select-danger"
                  placeholder="Route"
                  v-model="route"
                >
                  <el-option
                    v-for="route in routes"
                    class="select-danger"
                    :value="route.value"
                    :label="route.label"
                    :key="route.label"
                  ></el-option>
                </el-select>
              </base-input>
              <base-input
                label="3. Pickup Point Name"
                placeholder="Pickup Point"
                v-model="pickupPoint"
              ></base-input>
              <base-input
                label="4. Latitude"
                placeholder="Latitude"
                type="number"
                v-model="lat"
              ></base-input>
              <base-input
                label="5. Longitude"
                placeholder="Longitude"
                type="number"
                v-model="long"
              ></base-input>
              <base-input
                label="6. Radius"
                placeholder="Metre"
                type="number"
                v-model="radius"
              ></base-input>
            </div>

            <!-- Frequecy of Pickup -->
            <div class="col-lg-4" style="margin-left: 2%">
              <div class="row">
                <div class="col-lg-12 text-center">
                  <label style="font-size: 16px">6. Frequency of pickup</label>
                </div>
                <div class="row ml-auto mr-auto group-form">
                  <div class="col-lg-6">
                    <div class="row">
                      <label class="col-md-5 col-form-label">MON:</label>
                      <div class="col-lg-7">
                        <base-input v-model="monday" type="number"></base-input>
                      </div>
                      <label class="col-md-5 col-form-label">TUE:</label>
                      <div class="col-lg-7">
                        <base-input
                          v-model="tuesday"
                          type="number"
                        ></base-input>
                      </div>
                      <label class="col-md-5 col-form-label">WED:</label>
                      <div class="col-lg-7">
                        <base-input
                          v-model="wednesday"
                          type="number"
                        ></base-input>
                      </div>
                      <label class="col-md-5 col-form-label">THU:</label>
                      <div class="col-lg-7">
                        <base-input
                          v-model="thursday"
                          type="number"
                        ></base-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="row">
                      <label class="col-md-5 col-form-label">FRI:</label>
                      <div class="col-lg-7">
                        <base-input v-model="friday" type="number"></base-input>
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-md-5 col-form-label">SAT:</label>
                      <div class="col-lg-7">
                        <base-input
                          v-model="saturday"
                          type="number"
                        ></base-input>
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-md-5 col-form-label">SUN:</label>
                      <div class="col-lg-7">
                        <base-input v-model="sunday" type="number"></base-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Type of Bin -->
            <div class="col-lg-5" style="margin-left: 2%">
              <div class="row">
                <div class="col-lg-4"></div>
                <div class="col-lg-8 text-center">
                  <label style="font-size: 16px">7. List of Bin</label>
                </div>
                <div class="col-lg-4 text-center">
                  <base-input label="Add Bin">
                    <el-select
                      class="select-danger"
                      placeholder="Bins"
                      v-model="bin"
                    >
                      <el-option
                        v-for="bin in bins"
                        class="select-danger"
                        :value="bin.value"
                        :label="bin.label"
                        :key="bin.label"
                      ></el-option>
                    </el-select>
                  </base-input>
                  <base-button type="green" @click="addBin()">Add</base-button>
                </div>
                <div class="col-lg-8 ml-auto mr-auto group-form">
                  <el-table
                    :data="binData"
                    :header-cell-style="{
                      background: 'transparent',
                      border: 'none',
                      borderBottom: '0.5px solid #3d3f51',
                    }"
                    :cell-style="{
                      border: 'none',
                      borderBottom: '0.5px solid #3d3f51',
                    }"
                  >
                    <el-table-column
                      label="Bin Name"
                      prop="BinName"
                      :min-width="150"
                    ></el-table-column>
                    <el-table-column
                      v-if="false"
                      prop="BinID"
                      :min-width="150"
                    ></el-table-column>
                    <el-table-column
                      :min-width="135"
                      align="right"
                      label="Actions"
                    >
                      <div slot-scope="props">
                        <el-tooltip
                          content="Delete"
                          placement="bottom"
                          effect="light"
                        >
                          <base-button
                            @click.native="deleteBin(props.$index, props.row)"
                            class="remove btn-link"
                            type="danger"
                            size="sm"
                            icon
                          >
                            <i class="tim-icons icon-simple-remove"></i>
                          </base-button>
                        </el-tooltip>
                      </div>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
            <div class="col-lg-12 text-center">
              <base-button @click="addSchedule()" type="primary"
                >Edit Pickup</base-button
              >
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Select, Option, Table, TableColumn } from "element-ui";
import swal from "sweetalert2";
import { json } from "d3";

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      // Storing select value
      regions: [],
      routes: [],
      // Storing registered bins
      binData: [],
      bins: [],
      bin: "",
      NewBin: [],
      // Variable to store payload attributes
      custID: "",
      region: "",
      route: "",
      monday: 0,
      tuesday: 0,
      wednesday: 0,
      thursday: 0,
      friday: 0,
      saturday: 0,
      sunday: 0,
      checkPickupPoint: "",
      pickupPoint: "",
      lat: "",
      long: "",
      radius: "",
      pickupID: null,
    };
  },
  created() {
    this.getRegion();
    this.getRoute();
    this.getBins();
  },
  mounted() {
    this.pickupID = this.$route.params.pickupid;
    this.getPickupDetails(this.pickupID);
    this.getAssignedBins(this.pickupID);
  },
  methods: {
    addBin() {
      let binName;
      for (let i = 0; i < this.bins.length; i++) {
        if (this.bins[i].value == this.bin) {
          binName = this.bins[i].label;
        }
      }
      let data = {
        id: this.binData.length + 1,
        BinName: binName,
        BinID: null,
      };
      this.binData.push(data);
    },
    deleteRow(row) {
      let indexToDelete = this.binData.findIndex(
        (tableRow) => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.binData.splice(indexToDelete, 1);
      }
    },
    deleteBin(index, row) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false,
      }).then((result) => {
        if (row.BinID == null) {
          if (index > -1) {
            this.binData.splice(index, 1);
          }

          // this.deleteRow(row);
          swal({
            title: "Deleted!",
            text: `You deleted ${row.BinName}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
        } else {
          if (result.value) {
            this.$http
              .delete(`:9991/api/v1/customers/pickup/bin/${row.BinID}`)
              .then((res) => {
                if (!res.error) {
                  if (index > -1) {
                    this.binData.splice(index, 1);
                  }
                  // this.deleteRow(row);

                  swal({
                    title: "Deleted!",
                    text: `You deleted ${row.BinName}`,
                    type: "success",
                    confirmButtonClass: "btn btn-success btn-fill",
                    buttonsStyling: false,
                  });
                }
              });
          }
        }
      });
    },
    getBins() {
      this.$http.get(":9991/api/v1/setting/bin").then((res) => {
        if (!res.error) {
          const response = res.message;
          for (let i = 0; i < response.length; i++) {
            let data = {
              value: response[i].BintypeID,
              label: response[i].binname,
            };
            this.bins.push(data);
          }
          this.bin = this.bins[0].value;
        }
      });
    },
    getAssignedBins(pickupID) {
      this.$http
        .post(`:9991/api/v1/customers/pickup/bin/${pickupID}`)
        .then((res) => {
          if (!res.error) {
            const response = res.message;
            for (let i = 0; i < response.length; i++) {
              let data = {
                id: i,
                BinName: response[i].BinName,
                BinID: response[i].BinID,
              };
              this.binData.push(data);
            }
          }
        });
    },
    getRegion() {
      this.$http.get(":9991/api/v1/customers/region").then((res) => {
        if (!res.error) {
          let response = res.message;
          for (var i = 0; i < response.length; i++) {
            let data = {
              label: response[i].RegionName,
              value: response[i].RegionID,
            };
            this.regions.push(data);
          }
        } else {
          swal({
            title: "Data Error!",
            text: `${res.message}`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
        }
      });
    },
    getRoute() {
      this.$http.get(":9991/api/v1/customers/route").then((res) => {
        if (!res.error) {
          let response = res.message;
          for (var i = 0; i < response.length; i++) {
            let data = {
              label: response[i].RouteName,
              value: response[i].RouteID,
            };
            this.routes.push(data);
          }
        } else {
          swal({
            title: "Data Error!",
            text: `${res.message}`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
        }
      });
    },
    getPickupDetails(pickupID) {
      this.$http
        .post(":9991/api/v1/customers/pickup/" + pickupID)
        .then((res) => {
          if (!res.error) {
            console.log(res.message);

            const pickup = res.message;

            this.custID = pickup.CustID;
            for (let i = 0; i < this.regions.length; i++) {
              if (this.regions[i].label == pickup.RegionName) {
                this.region = this.regions[i].value;
              }
            }
            for (let i = 0; i < this.routes.length; i++) {
              if (this.routes[i].label == pickup.RouteName) {
                this.route = this.routes[i].value;
              }
            }

            console.log(this.route);
            console.log(this.region);

            this.pickupPoint = pickup.PickupName;
            this.checkPickupPoint = pickup.PickupName;
            this.lat = pickup.PickupLat;
            this.long = pickup.PickupLong;
            this.radius = pickup.PickupRadius;
            for (let i = 0; i < pickup.PickupFreq.length; i++) {
              this.monday = pickup.PickupFreq[0];
              this.tuesday = pickup.PickupFreq[1];
              this.wednesday = pickup.PickupFreq[2];
              this.thursday = pickup.PickupFreq[3];
              this.friday = pickup.PickupFreq[4];
              this.saturday = pickup.PickupFreq[5];
              this.sunday = pickup.PickupFreq[6];
            }
          }
        });
    },
    updatePickupPoint(payload, pickupID) {
      this.$http
        .put(":9991/api/v1/customers/pickup/" + pickupID, payload)
        .then((res) => {
          swal({
            title: "Updated!",
            text: `${res.message} ${this.pickupPoint}!`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          }).then((result) => {
            this.$router.push({
              path: `/Greencard/PickupPointUpdate/${this.custID}`,
            });
          });
        });
    },
    addSchedule() {
      let BinList = [];
      let PickupFreq = [];

      // Store Pickup Freq
      PickupFreq.push(parseInt(this.monday));
      PickupFreq.push(parseInt(this.tuesday));
      PickupFreq.push(parseInt(this.wednesday));
      PickupFreq.push(parseInt(this.thursday));
      PickupFreq.push(parseInt(this.friday));
      PickupFreq.push(parseInt(this.saturday));
      PickupFreq.push(parseInt(this.sunday));

      for (let i = 0; i < this.binData.length; i++) {
        if (this.binData[i].BinID == null) {
          BinList.push(this.binData[i].BinName);
        }
      }

      let NewBinList = [];
      for (let i = 0; i < BinList.length; i++) {
        for (let j = 0; j < this.bins.length; j++) {
          if (BinList[i] == this.bins[j].label) {
            NewBinList.push(this.bins[j].value);
          }
        }
      }

      if (this.checkPickupPoint != this.pickupPoint) {
        const payload = {
          custid: this.custID,
          regionid: this.region,
          routeid: this.route,
          pickupname: this.pickupPoint,
          pickupfreq: PickupFreq,
          pickuplat: parseFloat(this.lat),
          pickuplong: parseFloat(this.long),
          pickupradius: this.radius.toString(),
          binlist: NewBinList,
        };
        this.updatePickupPoint(payload, this.pickupID);
      } else {
        const payload = {
          custid: this.custID,
          regionid: this.region,
          routeid: this.route,
          pickupfreq: PickupFreq,
          pickuplat: parseFloat(this.lat),
          pickuplong: parseFloat(this.long),
          pickupradius: this.radius.toString(),
          binlist: NewBinList,
        };
        this.updatePickupPoint(payload, this.pickupID);
      }
    },
  },
};
</script>

<style scoped>
.style-title {
  text-align: center;
}
.group-form {
  border: solid red;
  border-radius: 20px;
  padding: 2%;
  margin-bottom: 2%;
  margin-right: 2%;
}
</style>
